// src/store/routeReplayThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { setJourneyPlotData } from "./routeReplaySlice";

// Async thunk to fetch journey data
export const fetchJourneyData = createAsyncThunk(
  "routeReplay/fetchJourneyData",
  async (thingId, { getState, dispatch, rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      if (!thingId) {
        return rejectWithValue("No thingId provided");
      }

      const response = await axios.get(
        `https://v3.dhundhoo.com/reports/catchmentReport/${thingId}?thingId=${thingId}`,
        {
          headers: {
            "x-dhundhoo-session": token,
          },
        }
      );

      // Dispatch the journey data to slice
      dispatch(setJourneyPlotData(response.data.allWayPoints));

      return response.data.allWayPoints;
    } catch (error) {
      console.error("Error fetching journey data:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
